import { Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';

export type LocaleOptionType = {
    name: Signal<string>;
    value: string;
    numeralValue: string;
};

@Injectable({
    providedIn: 'root',
})
export class LocaleService {
    private readonly localeOptions = [
        {
            name: toSignal(this.translocoService.selectTranslate('locale.english'), { initialValue: '' }),
            value: 'en',
            numeralValue: 'en-gb',
        },
        {
            name: toSignal(this.translocoService.selectTranslate('locale.danish'), { initialValue: '' }),
            value: 'da',
            numeralValue: 'da-dk',
        },
        {
            name: toSignal(this.translocoService.selectTranslate('locale.dutch'), { initialValue: '' }),
            value: 'nl',
            numeralValue: 'nl-nl',
        },
        {
            name: toSignal(this.translocoService.selectTranslate('locale.japanese'), { initialValue: '' }),
            value: 'ja',
            numeralValue: 'ja',

        },
        {
            name: toSignal(this.translocoService.selectTranslate('locale.norwegian'), { initialValue: '' }),
            value: 'nb',
            numeralValue: 'no',
        },
        {
            name: toSignal(this.translocoService.selectTranslate('locale.swedish'), { initialValue: '' }),
            value: 'sv',
            numeralValue: 'da-dk',
        },
        {
            name: toSignal(this.translocoService.selectTranslate('locale.french'), { initialValue: '' }),
            value: 'fr',
            numeralValue: 'fr',
        },
        {
            name: toSignal(this.translocoService.selectTranslate('locale.spanish'), { initialValue: '' }),
            value: 'es',
            numeralValue: 'da-dk',
        },
        {
            name: toSignal(this.translocoService.selectTranslate('locale.portuguese'), { initialValue: '' }),
            value: 'pt',
            numeralValue: 'da-dk',
        },
    ];

    constructor (private translocoService: TranslocoService) {}

    getLocaleOptions (): LocaleOptionType[] {
        return this.localeOptions;
    }

    getDefaultOption (): LocaleOptionType {
        return this.localeOptions[0]; // First option is English (default)
    }

    getNumeralValue (locale: string = ''): string {
        const option = this.localeOptions.find((opt) => opt.value === locale);
        return option?.numeralValue || 'en-gb';
    }
}
